import { render, staticRenderFns } from "./PeriodSwitchTab.vue?vue&type=template&id=c7cc6240&scoped=true&"
import script from "./PeriodSwitchTab.vue?vue&type=script&lang=js&"
export * from "./PeriodSwitchTab.vue?vue&type=script&lang=js&"
import style0 from "./PeriodSwitchTab.vue?vue&type=style&index=0&id=c7cc6240&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cc6240",
  null
  
)

export default component.exports